import React, { Component } from 'react'

import { Spinner, TRWrapper } from '../common/Helper';
import { Link, useSearchParams } from 'react-router-dom';
import { timeStats, formatSecs } from '../../lib/utils'
import moment from 'moment';
const IssuesTable = (props) => {
    const exportCSV = () => {
        const list = props.issues.map((item, idx) => {
            return [
                idx + 1,
                "\"" + item.title + "\"",
                item.timeSpent === null ? "NA" :
                    formatSecs(item.timeSpent),
                item.timeEstimate === null ? 'NA' :
                    formatSecs(item.timeEstimate),
                item.created_at ? moment(item.created_at).format('YYYY-MM-DD') : '',
                item.closed_at ? moment(item.closed_at).format('YYYY-MM-DD') : '',
                item.assignee ? item.assignee.name : 'Not Assigned',
                item.state
            ].join(',')
        });
        const headers = ["#", "Title", "Time Spent", "Time Estimated", "Created", "Closed", "Assignee", "Status"];
        const csv = "data:text/csv;charset=utf-8," + headers.join(",") + "\r\n" + list.join("\r\n");
        var encodedUri = encodeURI(csv);
        window.open(encodedUri);
    }
    let list = [];
    const [sp] =useSearchParams();
    const { error, issues, tagStatus } = props;
    if (error) {
        list.push(
            <TRWrapper colSpan="5" key="error">
                <div className="issue-empty" style={{ color: 'var(--ds-danger)' }}>{error}</div>
            </TRWrapper>);
    } else if (issues && issues.length === 0) {
        list.push(<TRWrapper colSpan="5" key="message">
            <div className="issue-empty">No issues to list</div>
        </TRWrapper>);
    } else if (issues) {
        list = issues.map((item, idx) => {
            return <tr key={item.id} className={item.state === 'closed' ? 'ds-tone-good-strong' :
                (item.timeSpent > 0 ? 'ds-tone-good' : '')}>
                <td className="ds-nums">{idx + 1}</td>
                <td>
                    <a href={item.url} target="_blank" rel="noreferrer">{item.title}</a>
                    {item.labels.map(l => <span key={l} className="issue-tag" style={{ marginLeft: '4px' }}>{l}</span>)}
                </td>
                <td>{item.assignee ? <Link to={`/member/${item.assignee.username}?${sp.toString()}`}>{item.assignee.name}</Link> : 'Not assigned'}</td>
                <td>
                    {timeStats(item)}
                </td>
            </tr>;
        });
    } else {
        list.push(<TRWrapper colSpan="5" key="loading">
            <Spinner />
        </TRWrapper>);
    }

    return <div className="ds-table-wrap ds-panel" style={{ borderRadius: 'var(--ds-radius-lg)' }}>
        <table className="ds-table">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Tickets {Object.keys(tagStatus).length > 0 && <span style={{ fontWeight: 400, textTransform: 'none' }}>· {Object.keys(tagStatus).join(', ')}</span>}</th>
                    <th>Assignee</th>
                    <th>Time<br /><span style={{ fontWeight: 400, textTransform: 'none' }}>spent / estimate</span></th>
                </tr>
            </thead>
            <tbody>
                {list}
            </tbody>
        </table>
    </div>;
}

export default IssuesTable;
